import React from 'react';
import {Container, Row} from 'react-bootstrap'
import { useTranslation } from "react-i18next";

const HeaderContainer = ({children, classes}) => {
    const { t } = useTranslation();

    return (
        <div className={`header-section section ${classes}`}>
            <a className="header-banner" href="https://tresbien.studio" target="_blank" rel="noopener noreferrer">
                {t("banner_tresbien")} <span>tresbien.studio →</span>
            </a>
            <Container fluid>
                <Row className={'align-items-center '}>
                    {children}
                </Row>
            </Container>
        </div>
    );
};

export default HeaderContainer;
